import '../components/filters.js'

// Event Listeners
document.addEventListener('change', (event) => {
    if (event.target.matches('#mobile-category')) {
        const categorySlug = event.target.value
        window.location.replace('/' + categorySlug)
    } else if (event.target.matches('[data-category]')) {
        const categoryUri = event.target.dataset.category
        window.location.replace('/' + categoryUri)
    }
})
